import React, { useEffect, useRef } from 'react';
import background from '../images/finalFinal.png';

export default (props) => null;
